import React from "react";
import {
  CustomMenuItemFragment,
  DefaultNavBarQuery,
  TopMenuItemFragment
} from "types/graphql-types";
import { AlternateLink } from "src/utils/localization/alternateLinks";
import { toValidatedTopMenuItems } from "./utils";
import MainMenu from "./MainMenu/MainMenu";
import { MenuPromosProviderProvider } from "./MenuPromosProvider";
import {
  MenuContentProviderContextValue,
  MenuContentProviderProvider
} from "./MenuContentProvider";
import TopMenu from "./TopMenu/TopMenu";

export type MegaMenuProps = {
  data: DefaultNavBarQuery["mainMenu"];
  fycUrl: string | undefined;
  searchUrl: string | undefined;
  topLinks: TopMenuItemFragment[] | undefined;
  alternateLinks: AlternateLink[];
  menuPrimaryCTA: CustomMenuItemFragment | undefined;
  promos: DefaultNavBarQuery["promos"]["nodes"] | undefined;
  variant?: "normal" | "desktop-compact";
  isTransparent?: boolean;
} & MenuContentProviderContextValue;

const MegaMenu: React.FC<MegaMenuProps> = ({
  topLinks,
  promos,
  cruisesLaunches,
  destinations,
  ships,
  ...props
}) => {
  const validatedTopMenuItems = toValidatedTopMenuItems(topLinks || []);
  const linksWithoutSFO = validatedTopMenuItems.filter(
    (l) => l.specialType !== "sfo"
  );

  return (
    <MenuContentProviderProvider
      cruisesLaunches={cruisesLaunches}
      destinations={destinations}
      ships={ships}
    >
      <MenuPromosProviderProvider content={promos}>
        <TopMenu
          searchUrl={props.searchUrl}
          alternateLinks={props.alternateLinks}
          topLinks={linksWithoutSFO}
          forceShowLinks={["rab"]}
        />

        <MainMenu {...props} topLinks={validatedTopMenuItems} />
      </MenuPromosProviderProvider>
    </MenuContentProviderProvider>
  );
};

export default MegaMenu;
